import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export default function AnswerOption({
  text,
  selected,
  correct,
  showCorrection,
  explanation,
  onClick,
}) {
  const theme = useTheme();

  const getResultStyle = () => {
    if (correct) {
      return {
        background: "rgba(76,175,80,0.15)",
        border: "2px solid rgba(76,175,80,0.6)",
        boxShadow: selected
          ? theme.custom.shadow.soft
          : "none",
      };
    }

    if (selected && !correct) {
      return {
        background: "rgba(244,67,54,0.18)",
        border: "2px solid rgba(244,67,54,0.7)",
      };
    }

    return {
      background: "rgba(255, 0, 0, 0.03)",
      border: "1px solid rgba(166, 0, 255, 1)",
      opacity: 1,
    };
  };

  return (
    <Box
      onClick={!showCorrection ? onClick : undefined}
      sx={{
        p: 2.5,
        borderRadius: 2,
        transition: "all 0.25s ease",
        cursor: showCorrection ? "default" : "pointer",
        ...(showCorrection
          ? getResultStyle()
          : selected
          ? {
              background: theme.custom.gradients.bluePurple,
              border: `2px solid ${theme.palette.primary.main}`,
              boxShadow: theme.custom.shadow.soft,
              color: "#fff",
            }
          : {
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
            }),
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          {showCorrection && correct && (
            <CheckCircleIcon color="success" fontSize="small" />
          )}
          {showCorrection && selected && !correct && (
            <CancelIcon color="error" fontSize="small" />
          )}

          <Typography fontWeight={600}  color="#fffcfcff">
            {text}
          </Typography>
        </Stack>

        {showCorrection && explanation && (
          <Typography fontWeight={600} color="#f1ee0bff">
            {explanation}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
